import { getConfig } from "@jti/fe-common";
import { getIsEvo } from "../../utils";
import { PvsApiEvo } from "./PvsApiEvo";
import { PvsApiLegacy } from "./PvsApiLegacy";
export class PvsApi {
    static init() {
        const config = getConfig();
        if (getIsEvo(config.PVS_URL)) {
            return new PvsApiEvo(config.PVS_URL, config.PVS_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"]);
        }
        return new PvsApiLegacy(config.PVS_URL, config.PVS_X_DES_AK_TENANT_TOKEN);
    }
}
//# sourceMappingURL=PvsApi.js.map